import React, { useContext } from "react";
import { useHistory, withRouter } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";

import DispatchContext from "../../contexts/DispatchContext";
import ErrorLine from "../elements/ErrorLine";
import DataFetcher from "../../utils/DataFetcher";
import { getResponse, dispError, dispSuccess } from "../../utils/Tools";

function FormPwds(props) {
  const appDispatch = useContext(DispatchContext);
  const history = useHistory();

  const validation = Yup.object().shape({
    pwd: Yup.string().matches(/^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[()[\]{}?!$%&/=*+~,.;#:<>-_]).{8,32}$/g, "Das Passwort muss mindestens 8 Zeichen umfassen.\nSie müssen 3 Zeichenarten verwenden.\nFolgende Zeichen sind erlaubt: Kleinbuchstaben (a - z), Großbuchstaben (A - Z), Ziffern (0 - 9), Sonderzeichen ( ) [ ] { } ? ! $ % & / = * + ~ , . ; : < > - _ #").required("Bitte geben Sie eine Passwort ein."),
    confirmPwd: Yup.string()
      .oneOf([Yup.ref("pwd"), null], "Passwörter müssen identisch sein.")
      .required("Bitte geben Sie eine Passwort ein.")
  });

  const initialValues = { pwd: "", confirmPwd: "" };
  const targetURL = "/user/reset-pwd/change";

  const onSubmit = (values, { setSubmitting }) => {
    let payload = { passwordResetToken: props.match.params.id, pwd: values.pwd };
    DataFetcher.fetch(targetURL, payload)
      .then(response => {
        if (!response.success) {
          setSubmitting(false);
          return appDispatch(dispError(response.msg));
        }
        appDispatch(dispSuccess(getResponse("012")));
        history.push("/");
      })
      .catch(error => {
        console.error(error);
        setSubmitting(false);
      });
  };

  return (
    <Formik initialValues={initialValues} validationSchema={validation} onSubmit={onSubmit}>
      {({ errors, touched, isSubmitting }) => (
        <Form>
          <div className="field">
            <p className="control has-icons-left has-icons-right">
              <Field name="pwd" type="password" placeholder="Neues Passwort" className={`input${touched.pwd && errors.pwd ? " is-danger" : ""}`} />
              <span className="icon is-small is-left">
                <i className="fas fa-envelope"></i>
              </span>
            </p>
            <ErrorMessage component={ErrorLine} name="pwd" />
          </div>
          <div className="field">
            <p className="control has-icons-left">
              <Field name="confirmPwd" type="password" placeholder="Passwort bestätigen" className={`input${touched.confirmPwd && errors.confirmPwd ? " is-danger" : ""}`} />
              <span className="icon is-small is-left">
                <i className="fas fa-lock"></i>
              </span>
            </p>
            <ErrorMessage component={ErrorLine} name="confirmPwd" />
          </div>
          <div className="field">
            <p className="control">
              <button className="button is-success" type="submit" disabled={isSubmitting}>
                Absenden
              </button>
            </p>
          </div>
        </Form>
      )}
    </Formik>
  );
}
export default withRouter(FormPwds);
